module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center text-sm-right",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    staticClass: "info",
    attrs: {
      "large": "",
      "router": "",
      "to": "/meetups"
    }
  }, [_vm._v("Explore Meetups")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center text-sm-left",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    staticClass: "info",
    attrs: {
      "large": "",
      "router": "",
      "to": "/meetup/new"
    }
  }, [_vm._v("Organize Meetup")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-carousel', {
    staticStyle: {
      "cursor": "pointer"
    }
  }, _vm._l((_vm.meetups), function(meetup) {
    return _c('v-carousel-item', {
      key: meetup.id,
      attrs: {
        "src": meetup.imageUrl
      },
      on: {
        "click": function($event) {
          return _vm.onLoadMeetup(meetup.id)
        }
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("\n            " + _vm._s(meetup.title) + "\n          ")])])
  }), 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('p', [_vm._v("Join our awesome meetups!")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-626cc2be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 52
// module chunks = 1